import React, { useEffect, useRef } from "react";
import { Grid, Typography } from "@mui/material";
import "./Pdf.scss";
import FooterPdfTemplate from "../../Branding/FooterPdfTemplate";
import { Footer } from "antd/es/layout/layout";
import { displayDoctorName } from "../../../utils/displayDoctorName";

const PdfFooter = React.memo(({ doctorData }) => {
  console.log("Doctor data", doctorData);
  // useEffect(() => {
  //   console.log("PdfFooter doctorData changed:", doctorData);
  //   console.log(
  //     "Doctor data reference:",
  //     doctorData === prevDoctorData ? "Same reference" : "New reference"
  //   );
  // }, [doctorData]);

  // const prevDoctorData = useRef(doctorData);
  // useEffect(() => {
  //   prevDoctorData.current = doctorData;
  // }, [doctorData]);
  const getImageType = (base64String) => {
    if (!base64String) return null;

    if (base64String.startsWith("/9j/")) {
      return "jpeg";
    } else if (base64String.startsWith("iVBORw0KGgo=")) {
      return "png";
    } else {
      return null; // Unknown format
    }
  };

  return (
    <Grid
      container
      sx={{
        display: "flex",
        justifyContent: "flex-end", // Aligns content to the end horizontally
        padding: 2,
        marginTop: "3rem",
      }}
    >
      <Grid
        item
        xs={12}
        sm={4}
        md={4}
        sx={{ borderBottom: "1px solid black", padding: "1.5 rem" }}
      >
        {doctorData?.doctor_signature &&
          doctorData?.doctor_signature.length > 0 && (
            <Grid item>
              <img
                src={`data:image/${getImageType(
                  doctorData?.doctor_signature[0]?.base64
                )};base64,${doctorData?.doctor_signature}`}
                className="logo-dark logo-img"
                alt="Doctor Signature"
                width="100px"
                height="60px"
                style={{ paddingBottom: "3px", paddingTop: "5px" }}
              />
            </Grid>
          )}

        <Typography variant="h6" className="pdf-section-title">
          <b>{displayDoctorName(doctorData)}</b>
        </Typography>
        <Typography variant="subtitle1" className="pdf-section-title">
          <b>{doctorData?.qualifications}</b>
        </Typography>
        <Typography variant="subtitle1" className="pdf-section-title">
          <b>
            Registration No. -{" "}
            {doctorData?.registration_no ? doctorData?.registration_no : "NA"}
          </b>
        </Typography>
        <Typography variant="subtitle1" className="pdf-section-title">
          <b>{doctorData?.department}</b>
          {doctorData?.specialization && ` - ${doctorData?.specialization}`}
        </Typography>
      </Grid>
      <Grid xs={12}>
        <FooterPdfTemplate />
      </Grid>
      {/* Doctor's Information */}
    </Grid>
  );
});

export default PdfFooter;
